const DEFAULT_AUTH_API_URL = "http://localhost:8080";

// Determina si estamos en desarrollo o producción
const isDevelopment = process.env.NODE_ENV === 'development' || 
                      (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'));

// Lee primero de window.env (dinámico, útil para producción sin rebuild)
// Luego de process.env (útil para desarrollo con archivos .env)
// Finalmente usa el default
const getAuthApiUrl = () => {
  // En desarrollo, usa rutas relativas (proxy)
  if (isDevelopment) {
    return ''; // Ruta relativa, el proxy la manejará
  }
  
  // En producción, usa la URL completa
  const raw =
    (typeof window !== 'undefined' && window.env?.REACT_APP_AUTH_API_URL) ||
    (typeof window !== 'undefined' && window.env?.REACT_APP_API_URL) ||
    process.env.REACT_APP_AUTH_API_URL ||
    process.env.REACT_APP_API_URL ||
    DEFAULT_AUTH_API_URL;
  return raw.endsWith("/") ? raw.slice(0, -1) : raw;
};

const AUTH_API_URL = getAuthApiUrl();

export const solicitudesService = {
    obtenerSolicitudes
};

async function obtenerSolicitudes() {
    const token = localStorage.getItem("token");
    
    if (!token) {
        throw new Error('No hay token de autenticación');
    }

    const response = await fetch(`${AUTH_API_URL}/api/solicitudes`, {
        method: 'GET',
        headers: {
            'Accept': '*/*',
            'Authorization': `Bearer ${token}`
        }
    });

    if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
            // Token inválido o expirado
            localStorage.removeItem("token");
            localStorage.removeItem("session");
            throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
        }
        throw new Error(`Error al obtener solicitudes: ${response.status}`);
    }

    const result = await response.json();
    return result;
}

